import * as actionTypes from './actionsTypes';

export function getSitesList(params) {
	return {
		type: actionTypes.SITES_LIST_GET,
		payload: {
			params,
		},
	};
}

export function getSitesZonesList(params) {
	return {
		type: actionTypes.SITES_ZONES_LIST_GET,
		payload: {
			params,
		},
	};
}

export function clearZonesList() {
	return {
		type: actionTypes.SITES_ZONES_LIST_CLEAR,
	};
}



// WEBPACK FOOTER //
// ./src/redux/new_store_structure/actions/sites.js